import { string } from 'fp-ts';
import { panic } from './invariant.js';
export function panicInternal(error) {
    if (string.isString(error)) {
        panic(error);
    }
    else {
        panic(error.message, error.details);
    }
}
//# sourceMappingURL=shared.js.map